// Plan prices and the copy derived from them. Edit src/config/pricingPlans.json,
// not this file — the static SEO generator reads the same JSON.
import pricingData from "./pricingPlans.json";

export const PRICING_PLANS = pricingData.plans;
export const PRICE_CURRENCY = pricingData.currency;

export const formatINR = (amount) => amount.toLocaleString("en-IN");

const [basicPlan, regularPlan, premiumPlan] = PRICING_PLANS;

export const TOP_PLAN = premiumPlan;

export const STARTING_PRICE = formatINR(basicPlan.price);
export const STARTING_PRICE_TEXT = `₹${STARTING_PRICE}/year`;

// "Basic (₹7,999/year), Regular (₹9,999/year) and Premium (₹13,999/year, most popular)"
const planPriceLabels = PRICING_PLANS.map(
  (plan) => `${plan.name} (₹${formatINR(plan.price)}/year${plan.popular ? ", most popular" : ""})`
);
export const PLAN_PRICE_LIST = `${planPriceLabels.slice(0, -1).join(", ")} and ${planPriceLabels.at(-1)}`;

export const PLAN_DIFFERENCES_TEXT =
  `${basicPlan.name} covers appointments, staff, clients, memberships, discount offers and invoices. ` +
  `${regularPlan.name} adds inventory, expense management and analytics. ` +
  `${premiumPlan.name} adds online appointment bookings, WhatsApp promotions and Instagram & Google listing promotions.`;

// schema.org Offer for "plans from" contexts (SoftwareApplication.offers)
export const startingOfferSchema = {
  "@type": "Offer",
  price: String(basicPlan.price),
  priceCurrency: PRICE_CURRENCY,
  description: `Plans from ${STARTING_PRICE_TEXT}. Free personalized demo available.`,
  url: "https://ayesalon.com/pricing/",
};

export const planOffersSchema = PRICING_PLANS.map((plan) => ({
  name: plan.name,
  price: String(plan.price),
  description: `${plan.subtitle}. Includes: ${plan.features.join(", ")}. Billed annually.`,
}));
